import * as paymentTypes from '../types/paymentTypes';
import { paymentService } from '../../services/paymentService';

export const initializePayment =
  (orderId, customer, gateway = 'flutterwave') =>
  async (dispatch) => {
    dispatch({ type: paymentTypes.INITIALIZE_PAYMENT_REQUEST });
    try {
      const initFn =
        gateway === 'squad' ? paymentService.initializeSquad : paymentService.initializeFlutterwave;
      const response = await initFn(orderId, customer);
      const data = response?.data || response;
      const inner = data?.data || data;
      const paymentUrl =
        inner?.paymentUrl || data?.paymentUrl || inner?.checkout_url || data?.checkout_url;
      const payload = { ...inner, ...data, paymentUrl };
      dispatch({
        type: paymentTypes.INITIALIZE_PAYMENT_SUCCESS,
        payload,
      });
      return { success: true, data: payload };
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message;
      dispatch({
        type: paymentTypes.INITIALIZE_PAYMENT_FAILURE,
        payload: errorMessage,
      });
      return { success: false, error: errorMessage };
    }
  };

export const verifyPayment = (txRef, gateway = 'flutterwave') => async (dispatch) => {
  dispatch({ type: paymentTypes.VERIFY_PAYMENT_REQUEST });
  try {
    const verifyFn =
      gateway === 'squad' ? paymentService.verifySquad : paymentService.verifyFlutterwave;
    const response = await verifyFn(txRef);
    const data = response?.data || response;
    const payload = data?.data || data;
    dispatch({
      type: paymentTypes.VERIFY_PAYMENT_SUCCESS,
      payload,
    });
    return { success: true, data: payload };
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    dispatch({
      type: paymentTypes.VERIFY_PAYMENT_FAILURE,
      payload: errorMessage,
    });
    return { success: false, error: errorMessage };
  }
};

export const clearPaymentError = () => (dispatch) => {
  dispatch({ type: paymentTypes.CLEAR_PAYMENT_ERROR });
};

export const clearPaymentMessage = () => (dispatch) => {
  dispatch({ type: paymentTypes.CLEAR_PAYMENT_MESSAGE });
};
